export default "__VITE_ASSET__CJAvvPFn__"